import { tabclixActions } from "./data-slice";
import axios from "axios";
import i18next from "i18next";
// THUNKS PART - IMPORTANT TO PUT LOGIC AFTER THE SLICE(if inside slice file)


// here we create a function - which immediately returns another function
export const initializeAppData = () => {
    // this function can be async 
    return async (dispatch) => {
        let params = (new URL(document.location)).searchParams;
        let code = params.get("tabclix"); 

  
       
        // we create a new async function where we send the request  
        const fetchAllData = async () => {
            // const response = await fetch(`https://v3.tabclix.com/api/get-data`);

        /**
         * Here we fetch the Css, for now it will stay here because it is the fastest way it applies css
         */
        const FormData = require('form-data');
        let adata = new FormData();

        adata.append('grant_type', 'client_credentials');
        adata.append('client_id', '11');
        adata.append('client_secret', 'Liz4iIG8kngWbcf0zmAOPiIEUk4S6cTK40ts1qqM');
        adata.append('scope', '');

        let config = {
          method: "post",
          url: `${process.env.REACT_APP_CMS_URL}/oauth/token`,
          data: adata,
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
        };

        let Cssconfig = {
          method: "get",
          url: `${process.env.REACT_APP_CMS_URL}/api/get-css-db`,
          headers: {
            userID: code,
            Authorization: "",
            actualURL: window.location.host
          },
        };

        await axios(config)
            .then((response) => {
            
                Cssconfig.headers.Authorization = `Bearer ${response.data.access_token}`
                axios(Cssconfig)
                    .then((res => {
                        // $("html").removeAttr('style')
                        Object.keys(res.data).map(function (key, index) {
                            document.documentElement.style.setProperty(`${key}`, `${res.data[key]}`);
                            const color = getComputedStyle(document.documentElement).getPropertyValue(`${key}`);
                        });
                    
                    }
                    
                    ))
                    .catch(err => {
                        console.log(err);
                    });
            })
            .catch((error) => {
                console.log(error);
            });

        /**
         * Here we fetch the data, needs further improvments
         */
            const response = await fetch(
              `${process.env.REACT_APP_CMS_URL}/api/get-data-db`,
              {
                headers: {
                  userID: code,
                },
              }
            );

            if (!response.ok) {
                throw new Error('Fetching data failed');
            }
            const data = await response.json();

            
            return data;
        }

        const findSpecificData =  (allData, dataToReturn) => {
            const returnedData = allData.filter(Data => Data.type === dataToReturn);

            // returns data
            return returnedData;
        }
        

        try {
            const allData = await fetchAllData();

            dispatch(tabclixActions.replaceAllData(allData));

            const headers = findSpecificData(allData,"header");
            dispatch(tabclixActions.replaceHeader(headers));

            const PageData = findSpecificData(allData, "Page");
            dispatch(tabclixActions.replacePages(PageData));

            const navIcon = findSpecificData(allData,"navIcon");
            dispatch(tabclixActions.replaceNavBar(navIcon));

            const thankyoupage = findSpecificData(allData, "thankyoupage");
            dispatch(tabclixActions.replaceTankyouPage(thankyoupage[0]));

            const language = findSpecificData(allData, "language");
            i18next.changeLanguage(language[0].default_language);
           
            let params = new URL(document.location).searchParams;
            let homePage = parseInt(params.get("tabclixhomepage")); 
            
            /** is setting what will appear on the app layout */
            dispatch(tabclixActions.setCurrentPage(homePage));
            
            /** maps over the ids that are to be genreated from mobile bar and validates default home page */
            navIcon.map( icon => {
                if(homePage === icon.idToGenerate) {
                    window.parent.postMessage("100%", "*");
                    document.getElementById("tabclix___div_root").style.height = "100%";
                }
            });

        } catch (error) {
            console.log(error);
        }

        // the created function is then called in try-catch to handle any errors
        
    }

}


// old version

// // here we create a function - which immediately returns another function
export const initializeAppDataold = () => {
    // this function can be async 
    return async (dispatch) => {
       
        // we create a new async function where we send the request  
        const fetchAllData = async () => {
            
            let Cssconfig = {
              method: "get",
              url: `${process.env.REACT_APP_CMS_URL}/api/get-css-local`,
            };
            await axios(Cssconfig)
                    .then((res => {
                        // $("html").removeAttr('style')
                        Object.keys(res.data).map(function (key, index) {
                            document.documentElement.style.setProperty(`${key}`, `${res.data[key]}`)
                            const color = getComputedStyle(document.documentElement).getPropertyValue(`${key}`)
                        });
        
                    }
                    ))
                    .catch(err => {
                        console.log(err);
                    });

            const response = await fetch(
              `${process.env.REACT_APP_CMS_URL}/api/get-data-local`
            );

            if (!response.ok) {
                throw new Error('Fetching data failed')
            }
            const data = await response.json();

            
            return data;
        }

        const findSpecificData =  (allData, dataToReturn) => {
            const returnedData = allData.filter(Data => Data.type === dataToReturn);

            // returns data
            return returnedData;
        }

        // const starterPages = data.filter(allData => allData.type === "Page");
        // const current = data.filter(allPages => allPages.id === 0);
        // const navBar = data.filter(allData => allData.type === "navIcon");


        try {
            const allData = await fetchAllData()
  
            dispatch(tabclixActions.replaceAllData(allData))

            const headers = findSpecificData(allData,"header")
            dispatch(tabclixActions.replaceHeader(headers))

            const PageData = findSpecificData(allData, "Page")
            dispatch(tabclixActions.replacePages(PageData))

            const navIcon = findSpecificData(allData,"navIcon")
            dispatch(tabclixActions.replaceNavBar(navIcon))

            let params = new URL(document.location).searchParams;
            let homePage = params.get("tabclixhomepage");

            dispatch(tabclixActions.setCurrentPage(parseInt(homePage)));

            if (homePage != "null") {
              window.parent.postMessage("100%", "*");
              document.getElementById("tabclix___div_root").style.height = "100%";
              
            }

        } catch (error) {
            console.log(error);
        }

        // the created function is then called in try-catch to handle any errors
        
    }

}

